import { render, staticRenderFns } from "./search.vue?vue&type=template&id=6bf9e693"
import script from "./search.vue?vue&type=script&lang=js"
export * from "./search.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bf9e693')) {
      api.createRecord('6bf9e693', component.options)
    } else {
      api.reload('6bf9e693', component.options)
    }
    module.hot.accept("./search.vue?vue&type=template&id=6bf9e693", function () {
      api.rerender('6bf9e693', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/modules/test/search.vue"
export default component.exports